// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"filter__wrapper__1IBTd","input":"filter__input__2tfas","list":"filter__list__1XYT4","couilles":"filter__couilles__oYFNu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/filter/filter.scss
// module id = 218
// module chunks = 0